import type { HTTPService } from "@soft-db/http";
import type { Plugin } from "vue";
import { API_SYMBOL, WS_SYMBOL } from "./injection-symbols";
import { MonitoringApi } from "./monitoring-api";
import { WebSocketService } from "./web-socket-service";

export type TokenProvider = () => Promise<string | null>;

type ApiOptions = {
	http: HTTPService;
	tokenProvider: TokenProvider;
	socketEndpoint: string;
};

export function createMonitoringApi(options: ApiOptions): Plugin {
	const { http, tokenProvider, socketEndpoint } = options;

	http.onRequest(async (_, config) => {
		const token = await tokenProvider();
		if (token == null) {
			return config;
		}

		config.headers["Authorization"] = `Bearer ${token}`;
		config.headers["x-api-version"] = "v16"
		return config;
	});

	return {
		install: (app) => {
			app.provide(API_SYMBOL, new MonitoringApi(http));
			app.provide(WS_SYMBOL, new WebSocketService(socketEndpoint, tokenProvider));
		},
	};
}

export * from "./api";
export * from "./composable/api";
export * from "./composable/websocket";
export * from "./monitoring-api";
export * from "./type";
